<template>
  <div
    v-if="initials"
    class="initials-graphic flex flex-col items-center justify-center bg-theme-disabled font-semibold"
  >
    <div class="text-weight-bold uppercase">{{ initials }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    email: { type: String, required: false },
    firstName: { type: String, required: false },
    lastName: { type: String, required: false },
    circleSize: { type: String, default: "32px" },
    fontSize: { type: String, default: "12px" },
  },

  computed: {
    initials() {
      if (!this.email) return;
      return this.firstName && this.lastName ? this.firstName[0] + this.lastName[0] : this.email[0].toUpperCase();
    },
  },
});
</script>

<style lang="scss" scoped>
.initials-graphic {
  width: v-bind(circleSize);
  height: v-bind(circleSize);

  border-radius: 50%;

  font-size: v-bind(fontSize) !important;
}
</style>
